(function (root) {
  'use strict';

  var DEFAULTS = {
    tier1Qty: 2,
    tier1Pct: 10,
    tier2Qty: 3,
    tier2Pct: 20,
    shipThreshold: 7500,
    shipCurrency: 'USD',
    excludeHandles: ['express-processing-illcurrency'],
    excludeTypes: ['Processing Fee'],
    excludeVendors: ['re:do'],
    excludeTags: ['shipping-addon'],
    minItemPrice: 500
  };

  function list(value) {
    if (Array.isArray(value)) return value;
    return String(value || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);
  }

  function lower(arr) {
    return list(arr).map(function (s) { return s.toLowerCase(); });
  }

  function money(cents, fmt) {
    if (typeof fmt === 'function') return fmt(cents);
    return '$' + (Math.round(Number(cents) || 0) / 100).toFixed(2);
  }

  // tagExcluded(handle) returns true / false, or null while the product tags are unknown.
  function countItems(cart, cfg, tagExcluded) {
    var handles = lower(cfg.excludeHandles);
    var types = lower(cfg.excludeTypes);
    var vendors = lower(cfg.excludeVendors);
    var qty = 0;
    var pending = [];
    (cart.items || []).forEach(function (item) {
      if (handles.indexOf(String(item.handle || '').toLowerCase()) > -1) return;
      if (types.indexOf(String(item.product_type || '').toLowerCase()) > -1) return;
      if (vendors.indexOf(String(item.vendor || '').toLowerCase()) > -1) return;
      if (item.gift_card) return;
      var unit = item.original_price != null ? Number(item.original_price) : Number(item.price);
      if (unit <= cfg.minItemPrice) return;
      if (tagExcluded) {
        var ex = tagExcluded(item.handle);
        if (ex === true) return;
        if (ex === null && item.handle && pending.indexOf(item.handle) === -1) pending.push(item.handle);
      }
      qty += Number(item.quantity) || 0;
    });
    return { qty: qty, pending: pending };
  }

  // Highest percentage from the automatic discounts Shopify applied to this cart.
  function appliedPct(cart) {
    var pct = 0;
    function take(app) {
      if (!app) return;
      if (app.type && app.type !== 'automatic') return;
      if (app.value_type !== 'percentage') return;
      var v = parseFloat(app.value);
      if (v > pct) pct = v;
    }
    (cart.cart_level_discount_applications || []).forEach(take);
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) { take(a.discount_application); });
    });
    return pct;
  }

  function state(cart, options, tagExcluded) {
    var cfg = {};
    var k;
    for (k in DEFAULTS) cfg[k] = DEFAULTS[k];
    for (k in (options || {})) if (options[k] != null && options[k] !== '') cfg[k] = options[k];
    ['tier1Qty', 'tier1Pct', 'tier2Qty', 'tier2Pct', 'shipThreshold', 'minItemPrice'].forEach(function (n) {
      cfg[n] = Number(cfg[n]);
    });

    var counted = countItems(cart, cfg, tagExcluded);
    var qty = counted.qty;
    var original = Number(cart.original_total_price != null ? cart.original_total_price : cart.items_subtotal_price) || 0;
    var total = Number(cart.total_price) || 0;
    var saved = Math.max(0, original - total);
    if (!saved && cart.total_discount) saved = Number(cart.total_discount) || 0;
    var pct = saved > 0 ? appliedPct(cart) : 0;

    var tierOn = 0;
    if (pct >= cfg.tier2Pct) tierOn = cfg.tier2Qty;
    else if (pct >= cfg.tier1Pct) tierOn = cfg.tier1Qty;

    var need = 0;
    var nextPct = 0;
    if (tierOn === cfg.tier1Qty) {
      need = Math.max(1, cfg.tier2Qty - qty);
      nextPct = cfg.tier2Pct;
    } else if (tierOn === 0 && qty < cfg.tier1Qty) {
      need = cfg.tier1Qty - qty;
      nextPct = cfg.tier1Pct;
    } else if (tierOn === 0 && qty < cfg.tier2Qty) {
      need = cfg.tier2Qty - qty;
      nextPct = cfg.tier2Pct;
    }

    var mode;
    if (tierOn === cfg.tier2Qty) mode = 'top';
    else if (tierOn === cfg.tier1Qty) mode = 'mid';
    else if (qty < cfg.tier1Qty) mode = 'start';
    else mode = 'offer';

    var steps = [
      { n: 1, label: 'In cart', on: qty >= 1 },
      { n: cfg.tier1Qty, label: cfg.tier1Pct + '% off', on: tierOn >= cfg.tier1Qty },
      { n: cfg.tier2Qty, label: cfg.tier2Pct + '% off', on: tierOn >= cfg.tier2Qty }
    ];

    var currency = String(cart.currency || '').toUpperCase();
    var ship = null;
    if (currency === String(cfg.shipCurrency).toUpperCase()) {
      ship = { left: Math.max(0, cfg.shipThreshold - total) };
    }

    return {
      qty: qty,
      pending: counted.pending,
      pct: pct,
      tierOn: tierOn,
      need: need,
      nextPct: nextPct,
      saved: saved,
      mode: mode,
      steps: steps,
      ship: ship,
      cfg: cfg
    };
  }

  function messageHtml(s, fmt) {
    var c = s.cfg;
    var word = s.need > 1 ? 'items' : 'item';
    switch (s.mode) {
      case 'start':
        return 'Add <b>' + s.need + ' more ' + word + '</b>, save <b>' + s.nextPct + '%</b>';
      case 'mid':
        return '<b>' + c.tier1Pct + '% off</b> unlocked, you save <b class="cw-tier__saved">' + money(s.saved, fmt) +
          '</b>, add <b>' + s.need + ' more</b> for ' + s.nextPct + '%';
      case 'top':
        // round 9: keep pulling after the top tier; the next item's saving = the tier % of the average counted item price
        var nextItem = s.qty === c.tier2Qty ? 'a 4th' : 'another';
        return '<b>' + c.tier2Pct + '% off</b> every item, add ' + nextItem + ' and it comes ' + c.tier2Pct + '% off too (<b class="cw-tier__saved">about ' +
          money(s.saved / Math.max(1, s.qty), fmt) + ' less</b>)';
      default:
        return 'Buy ' + c.tier1Qty + ' save ' + c.tier1Pct + '% · Buy ' + c.tier2Qty + '+ save ' + c.tier2Pct + '%';
    }
  }

  function shipHtml(s, fmt, hasCode) {
    if (!s.ship) return '';
    var lead = s.ship.left > 0
      ? '<b>' + money(s.ship.left, fmt) + '</b> away from free shipping'
      : 'Free shipping unlocked';
    // round 9: code holders are told the tiers still count (true once Combinations are on in Admin > Discounts)
    var tail = hasCode ? 'your code combines with the ' + s.cfg.tier2Pct + '%' : 'discounts apply automatically';
    return lead + ' · ' + tail;
  }

  function toText(html) {
    return String(html).replace(/<[^>]+>/g, '');
  }

  var api = {
    DEFAULTS: DEFAULTS,
    state: state,
    appliedPct: appliedPct,
    messageHtml: messageHtml,
    shipHtml: shipHtml,
    toText: toText
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }

  // Browser wiring
  var productCache = {};
  var tagCache = {};

  root.cwFetchProduct = root.cwFetchProduct || function (handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  };

  function readConfig(el) {
    var d = el.dataset;
    return {
      tier1Qty: d.tier1Qty,
      tier1Pct: d.tier1Pct,
      tier2Qty: d.tier2Qty,
      tier2Pct: d.tier2Pct,
      shipThreshold: d.shipThreshold,
      shipCurrency: d.shipCurrency,
      excludeHandles: d.excludeHandles != null ? list(d.excludeHandles) : null,
      excludeTypes: d.excludeTypes != null ? list(d.excludeTypes) : null,
      excludeVendors: d.excludeVendors != null ? list(d.excludeVendors) : null,
      excludeTags: d.excludeTags != null ? list(d.excludeTags) : null,
      minItemPrice: d.minItemPrice
    };
  }

  function seedTags(el) {
    list(el.dataset.taggedHandles).forEach(function (h) { tagCache[h] = true; });
    list(el.dataset.untaggedHandles).forEach(function (h) { if (tagCache[h] == null) tagCache[h] = false; });
  }

  function formatter() {
    var cs = root.VanillaCartState;
    if (cs && typeof cs.formatMoney === 'function') return function (c) { return cs.formatMoney(c); };
    if (root.Shopify && typeof root.Shopify.formatMoney === 'function') {
      return function (c) { return root.Shopify.formatMoney(c, root.money_format); };
    }
    return null;
  }

  function render(el, cart) {
    if (!el || !cart) return;
    var cfg = readConfig(el);
    var excludeTags = lower(cfg.excludeTags || DEFAULTS.excludeTags);
    var lookup = excludeTags.length
      ? function (h) { return tagCache[h] == null ? null : tagCache[h]; }
      : null;
    var s = state(cart, cfg, lookup);
    var fmt = formatter();

    if (!cart.item_count) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    el.setAttribute('data-cw-tier-qty', s.qty);
    el.setAttribute('data-cw-tier-on', s.tierOn);

    var msg = el.querySelector('[data-cw-tier-msg]');
    if (msg) msg.innerHTML = messageHtml(s, fmt);

    var stepEls = el.querySelectorAll('[data-cw-tier-step]');
    s.steps.forEach(function (step, i) {
      var li = stepEls[i];
      if (!li) return;
      li.classList.toggle('is-on', step.on);
      var dot = li.querySelector('[data-cw-tier-dot]');
      if (dot) {
        dot.innerHTML = step.on
          ? '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>'
          : String(step.n);
      }
      var sr = li.querySelector('[data-cw-tier-reached]');
      if (sr) sr.textContent = step.on ? ' (reached)' : '';
    });

    var shipEl = el.querySelector('[data-cw-tier-ship]');
    if (shipEl) {
      var hasCode = el.getAttribute('data-has-code') === 'true';
      var html = shipHtml(s, fmt, hasCode);
      shipEl.hidden = !html;
      shipEl.innerHTML = html;
    }

    if (s.pending.length && lookup) {
      Promise.all(s.pending.map(function (h) {
        return root.cwFetchProduct(h).then(function (p) {
          var tags = lower((p && p.tags) || []);
          tagCache[h] = excludeTags.some(function (t) { return tags.indexOf(t) > -1; });
        });
      })).then(function () {
        render(el, lastCart || cart);
      });
    }
  }

  var lastCart = null;

  function renderAll(cart) {
    lastCart = cart;
    document.querySelectorAll('[data-cw-tier]').forEach(function (el) {
      seedTags(el);
      render(el, cart);
    });
  }

  document.addEventListener('cart:updated', function (e) {
    renderAll(e.detail);
  });

  function boot() {
    var cs = root.VanillaCartState;
    if (cs && cs.cart && cs.cart.items && cs.cart.items.length) renderAll(cs.cart);
    else if (root.cwTierCart && root.cwTierCart.items) renderAll(root.cwTierCart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  root.cwCartTier = api;
  api.render = render;
})(typeof window !== 'undefined' ? window : this);
